import type {
  Direction,
  LogicalAlignment,
  PhysicalAlignment,
} from '@wix/editor-elements-common-utils';
import { castFromInheritIfNeeded } from '@wix/editor-elements-common-utils';
import type {
  RichTextBoxDefinition,
  RichTextBoxStyleProperties,
} from '../../RichTextBox.types';

const convertLogicalAlignmentToPhysical = (
  logicalAlignment: LogicalAlignment,
  direction: Direction,
): PhysicalAlignment => {
  if (logicalAlignment === 'center') {
    return 'center';
  }

  if (
    (logicalAlignment === 'start' && direction === 'ltr') ||
    (logicalAlignment === 'end' && direction === 'rtl')
  ) {
    return 'left';
  } else {
    return 'right';
  }
};

export const getPhysicalInputAlignment = (
  compData: RichTextBoxDefinition['data'],
  styleProperties: RichTextBoxStyleProperties,
  siteDirection: Direction,
) => {
  const computedInputDirection = castFromInheritIfNeeded(
    compData.inputDirection,
    castFromInheritIfNeeded(compData.direction, siteDirection),
  );
  const computedInputAlign = castFromInheritIfNeeded(
    styleProperties.inputAlign,
    styleProperties.align,
  );

  return convertLogicalAlignmentToPhysical(
    computedInputAlign,
    computedInputDirection,
  );
};
